/** @jsxImportSource @emotion/react */
"use client";

import type { MediaElementsProps, MediaElementsRef } from "@packages/media";
import {
  getContentImage,
  getContentTitle,
  useCurrentQueueItem,
} from "@packages/media";
import { forwardRef } from "react";

import {
  coreMediaStyles,
  mediaElementContainerStyles,
  useMediaClass,
} from "../../../../utils/media.emotion";
import { MediaElements } from "../MediaElements/MediaElements.emotion";

export const MediaElementContainer = forwardRef<
  MediaElementsRef,
  MediaElementsProps
>(({ mediaType, mediaSrc, bgAudioSrc, bgVolume, shouldPlayBg }, ref) => {
  const { currentItem } = useCurrentQueueItem();
  const mediaClass = useMediaClass();

  return (
    <div
      key={"mediaElementContainer"}
      css={[
        coreMediaStyles.mediaElementContainer,
        mediaElementContainerStyles[mediaClass],
        mediaType === "video"
          ? coreMediaStyles.mediaElementContainerVideo
          : null,
      ]}
    >
      <MediaElements
        key={"hallowMedia"}
        ref={ref}
        imgSrc={getContentImage(currentItem)}
        mediaSrc={mediaSrc}
        bgAudioSrc={bgAudioSrc}
        mediaType={mediaType}
        mediaTitle={getContentTitle(currentItem)}
        bgVolume={bgVolume}
        shouldPlayBg={shouldPlayBg}
      />
    </div>
  );
});

MediaElementContainer.displayName = "MediaElementContainer";
